import React from 'react';
import { Button, KIND } from 'baseui/button';

import Accordian from 'commons-ui/src/components/keyValueView/Accordian';
import copy from 'commons-ui/src/assets/misc/copy.png';
import { DataList, Loader } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import { ITournamentDetails } from '../types';

import { columnConfigs, tcnxColumnConfigs } from './listConfig';
import useStyles from './useStyles';
import useTimelineList from './useTimelineList';

interface GameplayTimelineListProps {
	getGameplayTimelineData: () => any;
	tournamentDetails: ITournamentDetails;
	gameName: string | null | undefined;
}

const GameplayTimelineList: React.FC<GameplayTimelineListProps> = (props) => {
	const { gameName, getGameplayTimelineData, tournamentDetails } = props;
	const {
		timelineIsCollapsed,
		setTimelineIsCollapsedHandler,
		dataFetchComplete,
		showLoader,
		copyToClipboard,
		handleDatalistFetchData
	} = useTimelineList({ getGameplayTimelineData, tournamentDetails });
	const classes = useStyles();
	let columnConfigsGameSpecific;
	switch (gameName) {
		case 'tcnx': {
			columnConfigsGameSpecific = tcnxColumnConfigs;
			break;
		}
		default: {
			columnConfigsGameSpecific = columnConfigs;
		}
	}

	const timelineLabel = (
		<div className={classes.labelWithFilter}>
			<div className={classes.labelText}>GamePlay Timeline</div>
			<div title='click to copy'>
				<Button kind={KIND.secondary} onClick={copyToClipboard}>
					<img className={classes.copyImage} src={copy} alt='' />
				</Button>
			</div>
		</div>
	);

	return (
		<>
			{showLoader && <Loader />}
			<Accordian
				label={timelineLabel}
				panelKey='unnamedPanel'
				isCollapsed={timelineIsCollapsed}
				setIsCollapsed={setTimelineIsCollapsedHandler}>
				{dataFetchComplete && (
					<DataList
						fetchData={handleDatalistFetchData}
						columnConfigs={columnConfigsGameSpecific}
						hideActions
						entity={LIST_ENTITY_NAMES.GAMEPLAY_TIMELINE}
						filterable={false}
						searchable={false}
					/>
				)}
			</Accordian>
		</>
	);
};

export default GameplayTimelineList;
